import { render, staticRenderFns } from "./taskForm.vue?vue&type=template&id=0cd37372&"
import script from "./taskForm.js?vue&type=script&lang=js&"
export * from "./taskForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports